// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._198mw{font-size:16px!important;font-weight:500!important;color:#fff!important;background-color:#ff5722!important;width:216px;height:52px;border-radius:12px!important;text-transform:none!important}._1cE5u:hover{background-color:#ff6738!important}._2HLTT{background-color:#fff!important;color:#ff5722!important}._2HLTT:hover{background-color:#f8f8f8!important}._3Pohi{background-color:#fff!important;color:#ff5722!important;border:1px solid #ddd!important}._3Pohi:hover{background-color:#f8f8f8!important}._3sX6h{background-color:rgba(255,87,34,.2)!important;color:#ff5722!important}._3sX6h:hover{background-color:rgba(255,87,34,.4)!important}._3sX6h:disabled{opacity:1!important;background-color:#f7f7f7!important;color:#0065dc!important}._3SBvh{width:100%!important}", ""]);
// Exports
exports.locals = {
	"button": "_198mw",
	"no-theme": "_1cE5u",
	"white-theme": "_2HLTT",
	"bordered-white-theme": "_3Pohi",
	"low-theme": "_3sX6h",
	"fullWidth": "_3SBvh"
};
module.exports = exports;
